const UPDATE_FIELD = "job/UPDATE_FIELD";

const initialState = {
  leftKey: "list",
  rightKey: "roi"
};

function jobReducer(state = initialState, action) {
  switch (action.type) {
    case UPDATE_FIELD:
      return {
        ...state,
        [action.key]: action.data
      };
    default:
      return state;
  }
}

export function getJob(state) {
  return state.job;
}

export function getLeftKey(state) {
  return getJob(state).leftKey;
}

export function getRightKey(state) {
  return getJob(state).rightKey;
}

export function updateLeftKey(key) {
  return { type: UPDATE_FIELD, data: key, key: "leftKey" };
}

export function updateRightKey(key) {
  return { type: UPDATE_FIELD, data: key, key: "rightKey" };
}

export default jobReducer;
